import { addDays, format } from 'date-fns';
import { useMemo } from 'react';

import { useActiveOrganization } from '@/features/organization/api/get-active-organization';

import { useListBlockedTime } from '../api';
import { closedDays } from './closed-days';

/** Days of this range under a closure, keyed by yyyy-MM-dd with the reason. */
export function useClosedDays(days: Date[]): Map<string, string> {
  const { data: organization } = useActiveOrganization();
  const timeZone = organization?.timezone ?? 'UTC';
  const { blockedTimes } = useListBlockedTime({
    from: days[0].toISOString(),
    to: addDays(days[days.length - 1], 1).toISOString(),
  });

  return useMemo(
    () =>
      closedDays(
        blockedTimes,
        days.map((day) => format(day, 'yyyy-MM-dd')),
        timeZone
      ),
    [blockedTimes, days, timeZone]
  );
}
